// extracted by mini-css-extract-plugin
export default {"container":"LanguageChanger_container__NOP7q","text":"LanguageChanger_text__20zjL"};